import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/configStore'
import { makeId, idPrefixes } from '@/services/uuid'

export const useTagStore = defineStore('tag', () => {
  const configStore = useConfigStore()
  const { config } = storeToRefs(configStore)

  const tags = computed(() => {
    return config.value?.tags || []
  })

  const getById = (id: string) => tags.value.find((tag) => tag.id === id)

  return {
    tags,
    getById
  }
})
